import { render, staticRenderFns } from "./RegisterJobFair.vue?vue&type=template&id=96caed80&scoped=true"
import script from "./RegisterJobFair.vue?vue&type=script&lang=ts"
export * from "./RegisterJobFair.vue?vue&type=script&lang=ts"
import style0 from "./RegisterJobFair.vue?vue&type=style&index=0&id=96caed80&prod&lang=css"
import style1 from "./RegisterJobFair.vue?vue&type=style&index=1&id=96caed80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96caed80",
  null
  
)

export default component.exports